import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

const DATE_FILTERS = ['Today', 'This Week', 'This Month', 'This Year'];

function PostsFilterByDate({ submenu }: { submenu?: boolean }) {
  const { appendSearchParam, removeSearchParam } = useSearchParamActions();

  return (
    <FilterMenu label="Posted At" submenu={submenu}>
      <DropdownMenuItem onClick={() => removeSearchParam('postedAt')}>
        All
      </DropdownMenuItem>
      {DATE_FILTERS.map((dateFilter) => (
        <DropdownMenuItem
          key={dateFilter}
          onClick={() => appendSearchParam('postedAt', dateFilter)}
        >
          {dateFilter}
        </DropdownMenuItem>
      ))}
    </FilterMenu>
  );
}

export default PostsFilterByDate;
